import styled, { css } from 'styled-components';
import { dimensions } from '../../styles';
import { FormLabel, Input } from '../form/styles';

const StyledTable = styled.table`
  ${(props) => css`
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    white-space: ${props.whiteSpace || ''};

    thead {
      display: table-header-group;
      z-index: 2;
    }

    th{
      padding: 10px 20px !important;
      font-weight: 800;
      font-size: 14px;
      line-height: 19px;
      text-transform: uppercase;
      color: #2B3C93;
      // text-align:center !important;
    }

    td {
      border: none;
      padding: 10px 20px;
      display: table-cell;
      vertical-align: ${props.alignTop && 'top'};
      font-weight: 600;
      font-size: 13px;
      line-height: 18px
      color: #010101;
      // text-align:center !important;

      & ${FormLabel}, & ${Input} {
        margin: 0px;
      }

    }

    tr:nth-of-type(even) td {
      background: rgba(242,242,242,0.5);
    }

    ${
      props.hover
        ? `tr:hover td { background-color:rgba(72, 96, 217, 0.1); cursor: pointer; }`
        : null
    } ${props.bordered ? `th, td { border-bottom: none; }` : null} ${
    props.striped
      ? `tr:nth-of-type(odd) td { background-color: rgba(72, 96, 217, 0.1); }`
      : null
  } th {
      border-top: none;
    }

    th:first-child,
    td:first-child {
      border-left: none;
      text-align: left !important;
    }

    th:last-child,
    td:last-child {
      border-right: none;
    }

    @media (min-width: 1170px) {
      th,
      td {
        padding: ${dimensions.unitSpacing}px ${dimensions.coreSpacing}px;
      }
    }

  `};
`;

export default StyledTable;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/table/styles.js